import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=bb7803b2&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=bb7803b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7803b2",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QTabs,QTab,QMarkupTable,QSkeleton,QDialog,QCard,QCardSection,QSpace,QBtn,QOptionGroup,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QTabs,QTab,QMarkupTable,QSkeleton,QDialog,QCard,QCardSection,QSpace,QBtn,QOptionGroup,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
